import Image from 'next/image';
import React from 'react';

import CTAButton from '~/shared/components/cta-button/cta-button';
import { PAGE_NAMES } from '~/shared/constants';
import { getLocaleLink } from '~/shared/helpers/browser-helpers';
import { getUrl } from '~/shared/helpers/string-helpers';
import { useTypedTranslation } from '~/shared/hooks';

import './suggested-course.scss';

import basicReading from '~/assets/basic-reading.webp';

const SuggestedCourse = ({ lng }) => {
  const t = useTypedTranslation(['button', 'text']);

  return (
    <section className="suggested-course">
      <div className="suggested-course__image">
        <Image
          alt={t('text.children-are-learning')}
          title={t('text.children-are-learning')}
          src={basicReading.src}
          width={554}
          height={448}
          loading="lazy"
        />
      </div>
      <div className="suggested-course__content">
        <h2 className="suggested-course__title">
          {t('text.video-course')}
          <br />
          <span className="suggested-course__title--highlight">{t('text.malenkiy-chitach')}</span>
        </h2>
        <p className="suggested-course__description">{t('text.12-years-work')}</p>
        <ul className="suggested-course__list">
          <li className="suggested-course__list-item">{t('text.formation-of-correct-reading')}</li>
          <li className="suggested-course__list-item">{t('text.to-increase-reading-speed')}</li>
          <li className="suggested-course__list-item">{t('text.development-of-concentration')}</li>
          <li className="suggested-course__list-item">{t('text.improving-a-child-memory')}</li>
        </ul>
        <p className="suggested-course__age">
          <span className="suggested-course__blue-bullet" /> {t('text.for-children-7-12-years-old')}
        </p>
        <div className="suggested-course__actions">
          <div className="suggested-course__button">
            <CTAButton
              link={getLocaleLink(
                getUrl({
                  link: PAGE_NAMES.VIDEO_COURSE,
                  alias: 'kurs-bazovogo-chitannya',
                }),
                lng,
              )}
              content={t('button.go-to-course')}
            />
          </div>
          <span className="suggested-course__label">{t('text.free')}</span>
        </div>
      </div>
    </section>
  );
};

export default SuggestedCourse;
